"use client";

import { createContext, use } from "react";

type LeadFormPersistedValues = {
  persistedFieldValues: Record<string, string>;
  postalLocationValues: { postalCode: string; location: string };
};

const EMPTY_PERSISTED_VALUES: LeadFormPersistedValues = {
  persistedFieldValues: {},
  postalLocationValues: { location: "", postalCode: "" },
};

const LeadFormPersistedValuesContext = createContext<LeadFormPersistedValues>(
  EMPTY_PERSISTED_VALUES,
);

/**
 * Exposes the machine's persistedFieldValues/postalLocationValues to step
 * inputs so their local visual state (radio checkmark, multi-select set,
 * text defaultValue) can be initialized from the machine on mount — the
 * mechanism that survives the step region's unmount/remount when it moves
 * into a fullscreen takeover Dialog.
 */
function useLeadFormPersistedValues(): LeadFormPersistedValues {
  return use(LeadFormPersistedValuesContext);
}

export { LeadFormPersistedValuesContext, useLeadFormPersistedValues };
